import { InjectionToken } from '@angular/core';
import { ActivationData } from './types';

export const ACTIVATION_SERVICE = new InjectionToken<IActivationService>('ActivationService');

export interface IActivationService {
  getActivationData(): ActivationData | null;
  setActivationData(data: ActivationData): void;
  isActivatedSchoolDevice(): boolean;
  isActivatedHomeDevice(): boolean;
  setPlayerGroupCode(playerGroupCode: string): void;
  getPlayerGroupCode(): string | null;
  deletePlayerGroupCode(): void;
  deleteActivationData(): void;
}
